import { render, staticRenderFns } from "./results-site-view.vue?vue&type=template&id=23be73f0&scoped=true"
import script from "./results-site-view.vue?vue&type=script&lang=ts"
export * from "./results-site-view.vue?vue&type=script&lang=ts"
import style0 from "./results-site-view.vue?vue&type=style&index=0&id=23be73f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23be73f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23be73f0')) {
      api.createRecord('23be73f0', component.options)
    } else {
      api.reload('23be73f0', component.options)
    }
    module.hot.accept("./results-site-view.vue?vue&type=template&id=23be73f0&scoped=true", function () {
      api.rerender('23be73f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/results/sections/results-site-view.vue"
export default component.exports